// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    Want to access
                    <br />
                    our tool?
                  </>
                }
                description="The access to the scheduling tool is restricted only to authorized people to prevent misuse of the tool."
              />
              <RotatingCardBack
                image={bgBack}
                title="Get Access"
                description="If you want to access the tool, please contact us. We will review your request and get back to you as soon as possible."
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/contact-us",
                  label: "Contact Us",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="calendar_month"
                  title="Monthly Updates"
                  description="Every month our tool gives new predictions and trains
                  itself with the data from the previous month to improve its accuracy."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="schedule"
                  title="Patrol Schedule"
                  description="Patrol routes are generated by the tool such that every police officer
                  gets allocated patrol area and time slot."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="query_stats"
                  title="Informed Estimation"
                  description="Multiple factors are taken into account to estimate the burglary rate in a given area and which
                  has the most impact on the crime rate."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="local_police"
                  title="Special Operations"
                  description="Once every four months, the tool generates a special operation plan
                  to target the areas with the highest predicted burglary rate."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
